{
  "books": [
    {
      "title": "Incrollabile",
      "description": "Tony Robbins sintetizza le regole pratiche per costruire libertà finanziaria: asset allocation semplice, costi bassi, disciplina psicologica e protezioni dai ribassi. Basato su interviste a grandi investitori, offre linee guida concrete per far crescere e preservare il patrimonio in ogni ciclo di mercato.",
      "image": "https://m.media-amazon.com/images/I/51OPrt5YiEL._SY522_.jpg",
      "url": "https://amzn.to/3Ulz4fi",
      "category": "Finanza personale"
    },
    {
      "title": "Pachidermi e pappagalli",
      "description": "Carlo Cottarelli smonta con dati e rigore i luoghi comuni sull'economia italiana: tasse, debito, evasione, moneta e lavoro. Un vademecum agile per riconoscere fake news e prendere decisioni più consapevoli in tema economico.",
      "image": "https://m.media-amazon.com/images/I/71TWyQ0O5IL._SY522_.jpg",
      "url": "https://amzn.to/3IwzVEE",
      "category": "Psicologia e decisioni"
    },
    {
      "title": "Il pensiero laterale",
      "description": "Edward de Bono introduce tecniche per generare idee originali e risolvere problemi in modo non convenzionale. Esercizi e strumenti pratici aiutano a superare gli schemi abituali e ad allenare la creatività applicata al lavoro e alla vita quotidiana.",
      "image": "https://m.media-amazon.com/images/I/81nnpnZwoHL._SY466_.jpg",
      "url": "https://amzn.to/3TTMXlM",
      "category": "Creatività e problem solving"
    },
    {
      "title": "Il potere di adesso",
      "description": "Eckhart Tolle mostra come ritrovare presenza e lucidità vivendo nel momento presente. Un percorso di consapevolezza per ridurre ansia e ruminazione mentale, migliorare relazioni e benessere personale.",
      "image": "https://m.media-amazon.com/images/I/71pX6FyRvvL._SY522_.jpg",
      "url": "https://amzn.to/3Qpi6LX",
      "category": "Crescita personale"
    },
    {
      "title": "L'investitore intelligente",
      "description": "Il classico di Benjamin Graham: i principi del value investing, il margine di sicurezza e l'allegoria di Mr. Market. Un metodo disciplinato per valutare aziende e gestire il rischio nel lungo periodo.",
      "image": "https://m.media-amazon.com/images/I/71BxAx4EPAL._SY466_.jpg",
      "url": "https://amzn.to/3T6WKne",
      "category": "Investimenti"
    },
    {
      "title": "Pensieri lenti e veloci",
      "description": "Daniel Kahneman spiega i due sistemi decisionali della mente: rapido e intuitivo vs lento e analitico. Scopri bias cognitivi e scorciatoie mentali che influenzano scelte, finanza e negoziazioni.",
      "image": "https://m.media-amazon.com/images/I/61wGSkPKaeL._SY522_.jpg",
      "url": "https://amzn.to/4a0gL6d",
      "category": "Psicologia e decisioni"
    },
    {
      "title": "Il perscorso",
      "description": "Guida introduttiva all'investimento value: come analizzare i fondamentali, cercare valore intrinseco e mantenere una prospettiva di lungo periodo. Un percorso chiaro per chi vuole investire con metodo.",
      "image": "https://m.media-amazon.com/images/I/61XTOMnSKxS._SY466_.jpg",
      "url": "https://amzn.to/48RelVU",
      "category": "Investimenti"
    },
    {
      "title": "Un passo avanti a Wall Street",
      "description": "Peter Lynch mostra come gli investitori privati possano battere i professionisti investendo in ciò che conoscono. Dalle 'tenbagger' all'analisi del business, un approccio concreto per trovare buone aziende.",
      "image": "https://m.media-amazon.com/images/I/81KtAf1A7vL._SY522_.jpg",
      "url": "https://amzn.to/4c7Uepc",
      "category": "Investimenti"
    },
    {
      "title": "Padre ricco padre povero",
      "description": "Robert Kiyosaki contrasta due mentalità opposte sul denaro e sul lavoro. Concetti-chiave: attivi vs passivi, educazione finanziaria, flussi di cassa e imprenditorialità personale.",
      "image": "https://m.media-amazon.com/images/I/71e3s6py2HL._SY466_.jpg",
      "url": "https://amzn.to/3V98yHW",
      "category": "Finanza personale"
    },
    {
      "title": "Come trattare gli altri e farseli amici",
      "description": "Il classico di Dale Carnegie sui fondamenti delle relazioni efficaci: ascolto autentico, empatia, riconoscimento e comunicazione positiva. Strumenti pratici per influenzare senza manipolare.",
      "image": "https://m.media-amazon.com/images/I/61ign-XInrL._SY522_.jpg",
      "url": "https://amzn.to/44kPVDJ",
      "category": "Crescita personale"
    },
    {
      "title": "La psicologia dei soldi",
      "description": "Morgan Housel racconta, con storie brevi, perché il comportamento conta più della matematica negli investimenti. Bias, fortuna e rischio spiegati in modo semplice per migliorare le decisioni finanziarie.",
      "image": "https://m.media-amazon.com/images/I/61wevnM4XVL._SY522_.jpg",
      "url": "https://amzn.to/3wG2qwI",
      "category": "Finanza comportamentale"
    },
    {
      "title": "L'uomo più ricco di Babilonia",
      "description": "Parabole senza tempo insegnano regole di buon senso: pagati per primi, risparmia almeno il 10%, evita debiti inutili, investi con prudenza. Un classico della finanza personale.",
      "image": "https://m.media-amazon.com/images/I/71fe+8LgxML._SY522_.jpg",
      "url": "https://amzn.to/3wNvwua",
      "category": "Finanza personale"
    },
    {
      "title": "Manuale di finanza personale",
      "description": "Guida operativa a budget, cuscinetto di emergenza, assicurazioni, previdenza e investimenti. Strumenti pratici per impostare obiettivi e gestire il denaro con metodo.",
      "image": "https://m.media-amazon.com/images/I/61VJzieuciS._SY522_.jpg",
      "url": "https://amzn.to/3IBuVOJ",
      "category": "Finanza personale"
    },
    {
      "title": "Da zero a uno",
      "description": "Peter Thiel spiega come creare aziende che passano da zero a uno: innovazione verticale, vantaggi di monopolio, pensiero contrarian e focus su quote di mercato piccole ma dominabili.",
      "image": "https://m.media-amazon.com/images/I/61K41kgcX5L._SY522_.jpg",
      "url": "https://amzn.to/47eM50j",
      "category": "Startup e business"
    },
    {
      "title": "Traction: Get a Grip on Your Business",
      "description": "Gino Wickman presenta l'EOS (Entrepreneurial Operating System): visione condivisa, priorità trimestrali (Rocks), metriche chiare e riunioni efficaci per aumentare la trazione aziendale.",
      "image": "https://m.media-amazon.com/images/I/81bziOVlOwL._SY522_.jpg",
      "url": "https://amzn.to/4e8Pj7U",
      "category": "Startup e business"
    },
    {
      "title": "I 4 pilastri dell'investimento",
      "description": "William J. Bernstein unisce teoria dei mercati, storia, psicologia e pratica per costruire portafogli semplici e robusti. Centrale: diversificazione ampia e costi contenuti.",
      "image": "https://m.media-amazon.com/images/I/51sTjTZHjML._SY466_.jpg",
      "url": "https://amzn.to/3IWmj5D",
      "category": "Investimenti"
    },
    {
      "title": "4 ore alla settimana",
      "description": "Tim Ferriss propone automazione, delega e mini-pensioni per liberare tempo e massimizzare l'impatto. Dritte pratiche per ripensare lavoro e produttività personale.",
      "image": "https://m.media-amazon.com/images/I/71xDpKjVcWL._SY466_.jpg",
      "url": "https://amzn.to/4f1KI7M",
      "category": "Produttività e focus"
    },
    {
      "title": "Deep work",
      "description": "Cal Newport mostra come coltivare periodi di concentrazione profonda per lavori cognitivi complessi. Strategie per ridurre distrazioni, creare rituali e produrre risultati di qualità.",
      "image": "https://m.media-amazon.com/images/I/61VW9gfj-eL._SY466_.jpg",
      "url": "https://amzn.to/4eKTtUb",
      "category": "Produttività e focus"
    },
    {
      "title": "Libertà finanziaria",
      "description": "Metodo passo per passo per eliminare i debiti, creare un fondo di emergenza e costruire stabilità finanziaria duratura.",
      "image": "https://m.media-amazon.com/images/I/716hcjArU5L._SY522_.jpg",
      "url": "https://amzn.to/42cIKxk",
      "category": "Finanza personale"
    },
    {
      "title": "Kakebo. L'originale 2026. Il libro dei conti di casa",
      "description": "Agenda-bilancio ispirata alla tradizione giapponese: uno strumento pratico per tracciare spese, fissare obiettivi e migliorare il controllo del budget.",
      "image": "https://m.media-amazon.com/images/I/51GKBoaMJ-L._SY522_.jpg",
      "url": "https://amzn.to/4mMTmvk",
      "category": "Finanza personale"
    },
    {
      "title": "Sei già ricco ma non lo sai",
      "description": "Manuale pratico che mostra come risparmiare e investire partendo dalle proprie risorse, trasformando piccole abitudini in risultati finanziari concreti.",
      "image": "https://m.media-amazon.com/images/I/71Z76eX4AwL._SY522_.jpg",
      "url": "https://amzn.to/3I1JcYn",
      "category": "Finanza personale"
    },
    {
      "title": "Value Investing: La guida definitiva",
      "description": "Manuale completo sui principi del value investing: analisi fondamentale, valutazione aziendale e strategie per ottenere rendimenti superiori.",
      "image": "https://m.media-amazon.com/images/I/71O9wONehjL._SY522_.jpg",
      "url": "https://amzn.to/47IkYgz",
      "category": "Investimenti"
    },
    {
      "title": "Nudge – La spinta gentile",
      "description": "Come piccoli cambiamenti nel design delle scelte possono guidare decisioni finanziarie e quotidiane più consapevoli ed efficaci.",
      "image": "https://m.media-amazon.com/images/I/61MID4dyCYL._SY522_.jpg",
      "url": "https://amzn.to/3I6DULc",
      "category": "Finanza comportamentale"
    },
    {
      "title": "Misbehaving",
      "description": "La nascita dell’economia comportamentale raccontata dal Premio Nobel Richard Thaler: come errori, bias e irrazionalità influenzano mercati e investitori.",
      "image": "https://m.media-amazon.com/images/I/71QDG1hXdHL._SY522_.jpg",
      "url": "https://amzn.to/3JJ2lPw",
      "category": "Finanza comportamentale"
    },
    {
      "title": "Intelligenza emotiva",
      "description": "Il ruolo centrale delle emozioni nelle decisioni: come riconoscerle e gestirle per migliorare relazioni, lavoro e scelte finanziarie.",
      "image": "https://m.media-amazon.com/images/I/71UXQ-i8siL._SY522_.jpg",
      "url": "https://amzn.to/46ijloq",
      "category": "Finanza comportamentale"
    },
    {
      "title": "Detto, Fatto! (Getting Things Done)",
      "description": "Il metodo GTD di David Allen per organizzare attività, ridurre lo stress e raggiungere obiettivi con chiarezza ed efficienza.",
      "image": "https://m.media-amazon.com/images/I/61CmRosNJEL._SY522_.jpg",
      "url": "https://amzn.to/3VB7mMs",
      "category": "Produttività e focus"
    },
    {
      "title": "Ingoia il rospo",
      "description": "21 tecniche pratiche di Brian Tracy per smettere di procrastinare, affrontare i compiti più importanti e aumentare la produttività.",
      "image": "https://m.media-amazon.com/images/I/81IHVOQo-xL._SY522_.jpg",
      "url": "https://amzn.to/4p4djz1",
      "category": "Produttività e focus"
    },
    {
      "title": "Il principio 80/20",
      "description": "Richard Koch mostra come identificare il 20% delle azioni che produce l’80% dei risultati, e concentrare lì energia e risorse.",
      "image": "https://m.media-amazon.com/images/I/61GbO6UCsQL._SY522_.jpg",
      "url": "https://amzn.to/3I75LuT",
      "category": "Produttività e focus"
    },
    {
      "title": "Le 7 regole per avere successo",
      "description": "Un classico della crescita personale: sette abitudini efficaci per migliorare performance, leadership e relazioni.",
      "image": "https://m.media-amazon.com/images/I/61wEsTymPnL._SY522_.jpg",
      "url": "https://amzn.to/3VD1D8V",
      "category": "Crescita personale"
    },
    {
      "title": "Pensa e arricchisci te stesso",
      "description": "Il manuale più influente sul mindset del successo: pensiero positivo, obiettivi chiari e autosuggestione come leve per la ricchezza.",
      "image": "https://m.media-amazon.com/images/I/81tPjHyViFL._SY522_.jpg",
      "url": "https://amzn.to/46m8YzS",
      "category": "Crescita personale"
    },
    {
      "title": "Chi ha spostato il mio formaggio?",
      "description": "Favola motivazionale che insegna come affrontare i cambiamenti in modo proattivo, in ambito personale e professionale.",
      "image": "https://m.media-amazon.com/images/I/71G5qSZGixL._SY522_.jpg",
      "url": "https://amzn.to/3I4gN44",
      "category": "Crescita personale"
    },
    {
      "title": "Come ottenere il meglio da sé e dagli altri",
      "description": "Tecniche pratiche di Anthony Robbins per migliorare comunicazione, motivazione ed equilibrio interiore, con applicazioni a carriera e finanza personale.",
      "image": "https://m.media-amazon.com/images/I/61IohM8Vv0L._SY522_.jpg",
      "url": "https://amzn.to/45PjqQt",
      "category": "Crescita personale"
    },
    {
      "title": "Partire leggeri. Il metodo Lean Startup",
      "description": "Eric Ries illustra la metodologia Lean Startup: sperimentazione rapida, validazione continua e cicli di apprendimento per creare aziende innovative ed efficaci.",
      "image": "https://m.media-amazon.com/images/I/719a+TMYk9L._AC_UL640_FMwebp_QL65_.jpg",
      "url": "https://amzn.to/4mKVkft",
      "category": "Startup e business"
    },
    {
      "title": "Good to Great",
      "description": "Jim Collins analizza cosa distingue le aziende eccellenti da quelle semplicemente buone, con principi di leadership e gestione applicabili anche a progetti personali.",
      "image": "https://m.media-amazon.com/images/I/61+ncVNIzWL._SY522_.jpg",
      "url": "https://amzn.to/4g5mlYN",
      "category": "Startup e business"
    }
  ]
}

